import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { usernameSelector, isLogginInSelector } from '../selectors/authSelectors';
import { login } from '../actions/authActions';
import LoginForm from '../components/LoginForm/LoginForm';

const mapStateToProps = createStructuredSelector({
    username: usernameSelector,
    isLogginIn: isLogginInSelector
});

const mapDispatchToProps = { login };

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(LoginForm)
);
